@if (entry.base?.display) {
  <form
    [formGroup]="form"
    [connect]="'payloadStates.' + entry?.formControlAttributes.connectPath"
    class="event-form"
    >
    <mat-form-field appearance="outline" class="event">
      <mat-label>{{ entry?.formControlAttributes?.label }}</mat-label>
      <mat-select
        aria-label="SEP Reason"
        [formControlName]="entry?.formControlAttributes?.formControlName"
        [compareWith]="compareWithFn"
        >
        @for (reason of eventReasons; track reason) {
          <mat-option [value]="reason">
            {{ reason.label }}
          </mat-option>
        }
      </mat-select>
      @if (
        formControls[entry?.formControlAttributes?.formControlName]?.errors
        ?.required
        ) {
        <mat-error
          >
          Required
        </mat-error>
      }
    </mat-form-field>
  </form>
}
